import * as React from 'react';
import classNames from 'classnames';

import { StringMode } from '@comall-backend-builder/types';

export class StringPointPriceMode extends StringMode {
    /**
     * 商品接口中，普通商品以价格形式展示(100.00)，积分商品以积分形式展示(100)
     */
    public getAvailableDisplayComponent(value: any, displayInfo: any) {
        const { className, style, row } = displayInfo;
        displayInfo = {
            ...displayInfo,
            className: classNames('type-string', className),
        };
        // 积分商品
        if (row.type === 'FK_POINTS') {
            value = Number(value).toString();
        }
        return (
            <span className={className} style={style}>
                {value}
            </span>
        );
    }
}
